import { Component, EventEmitter, Injector, Input, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { CommonService } from 'src/app-core/services/common.service';
import { InsuranceService } from 'src/app/insurance/insurance.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { InsuranceProviderIdEnum } from 'src/app/shared/app-common-enum';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-orders-insurance',
    templateUrl: './orders-insurance.component.html',
    styleUrls: ['./orders-insurance.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersInsuranceComponent extends AppComponentBase implements OnInit {
    @ViewChild('insuranceForm', { static: true }) insuranceForm: NgForm;
    @Input() set insuranceDetailsParams(data: any) {
        if (data) {
            this.insuranceDetails = data;
            this.insuranceDetails.coverage_Rate = data.coverage_Rate ? parseFloat(data.coverage_Rate).toFixed(2) : '0.00';
            this.insuranceDetails.minimum_Charge = data.minimum_Charge ? parseFloat(data.minimum_Charge).toFixed(2) : '0.00';
            this.loadData();
        }
    }
    @Input() isQuote: boolean;
    @Input() isPanelExpended: boolean;
    @Input() readOnly: boolean;
    @Input() isConvertToQuote: boolean;
    @Input() set defaultCoverageTypeParam(type: any) {

        this.defaultCoverageType = type;
        this.setInsuraceCoverageType();
    }
    @Output() emitCalCostBreakdown: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitCoverageTypeChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitUpdateMarkupPercentage: EventEmitter<any> = new EventEmitter<any>();
    coverageTypeList: any;
    categoryLookup: any;
    insurerList: any;
    commonDataModel = new CommonDataModel();
    insuranceDataModel = this.commonDataModel.insuranceModel;
    insuranceDetails: any;
    isEstimateInsuranceUpdateOnChange = false;
    defaultCoverageType: any;
    insProvHaysCompany: any;
    insuredTotalCost = 0;
    selectAllChecked: boolean = true;
    insuranceProviderIdEnum: typeof InsuranceProviderIdEnum = InsuranceProviderIdEnum;

    constructor(
        injector: Injector,
        private insuranceService: InsuranceService,
        private commonMethod: CommonMethod,
        private commonService: CommonService) {
        super(injector);
    }

    ngOnInit() {
        if (!this.insuranceDetails) {
            this.loadData();
        }
        this.commonMethod.getValue.subscribe(data => {
            this.insuredTotalCost = data;
        });
    }

    loadData() {
        const insuranceDetailsSnapshot = this.insuranceDetails;
        if (insuranceDetailsSnapshot) {
            this.categoryLookup = _.cloneDeep(insuranceDetailsSnapshot.coverageCategory);
            this.commonService.objectMapping(this.insuranceDataModel, insuranceDetailsSnapshot);
            this.emitUpdatedInsurance();
            this.checkSelectAll();
        } else {
            this.insuranceService.getCoverageCategories().subscribe(response => {
                if (!this.insuranceDetails) {
                    this.categoryLookup = response.data;
                    this.checkSelectAll();
                }
            });
        }
        this.insuranceService.getInsuranceProviders().subscribe(response => {
            this.insurerList = _.cloneDeep(response.data);
            this.insProvHaysCompany = this.insurerList.find(item =>
                item.insuranceProviderName.toLowerCase() === 'hays companies'
            );
            if (!insuranceDetailsSnapshot) {
                const activeInsurer = response.data.find(x => x.isActive);
                this.insuranceDataModel.insuranceProviderId = activeInsurer.insuranceId;
                this.setInsuraceCoverageType();
                this.loadCoverageType(activeInsurer.insuranceId);
            } else {
                this.loadCoverageType(insuranceDetailsSnapshot.insuranceProviderId);
            }
        });
    }

    checkSelectAll() {
        this.selectAllChecked = this.categoryLookup.every(
            (category) => category.isActive
        );
    }


    setInsuraceCoverageType() {
        if (this.coverageTypeList && this.coverageTypeList.length) {
            const typeStanderd = this.coverageTypeList.find(item => item.insuranceCategoryName == 'Standard');
            const typeLLC = this.coverageTypeList.find(item => item.insuranceCategoryName == 'Limited Liability Coverage');
            const typeJSO = this.coverageTypeList.find(item => item.insuranceCategoryName == 'JSO');
            const typeCustomContainerOrder = this.coverageTypeList.find(item => item.insuranceCategoryName == 'Custom Container Order');
            switch (this.defaultCoverageType) {
                case 1: this.insuranceDataModel.insuranceRateId = typeStanderd.insuranceRateId;
                    break;
                case 2: this.insuranceDataModel.insuranceRateId = typeJSO.insuranceRateId;
                    break;
                case 3: this.insuranceDataModel.insuranceRateId = typeLLC.insuranceRateId;
                    break;
                case 4: this.insuranceDataModel.insuranceRateId = typeJSO.insuranceRateId;
                    break;
                case 5: this.insuranceDataModel.insuranceRateId = typeCustomContainerOrder.insuranceRateId;
                    break;
                case 6: this.insuranceDataModel.insuranceRateId = typeLLC.insuranceRateId;

                    break;
                case 7: this.insuranceDataModel.insuranceRateId = typeJSO.insuranceRateId;
                    break;
                default:
                    break;
            }
            this.getInsuranceRateByIdAndCost();
        }
    }

    loadCoverageType(insuranceId: number) {
        this.insuranceService.getCategoriesLookup(insuranceId).subscribe(response => {
            if (response.isSuccess) {
                this.coverageTypeList = response.data;
            }
            if (!this.insuranceDetails) {
                this.setInsuraceCoverageType();
            }
            // this.insuranceDetails = null;
        });
    }

    getInsuranceRate(insuranceRateId: number) {
        this.insuranceService.getRateById(`&InsuranceRateId=${insuranceRateId}`).subscribe(response => {
            if (response.isSuccess) {
                this.insuranceDataModel.coverage_Rate = response.data.cost.toFixed(2);
                this.insuranceDataModel.markupPercentage = response.data.markupPercentage;
                this.insuranceDataModel.minimum_Charge = response.data.minimum_Charge.toFixed(2);
                this.insuranceDataModel.excessValueThreshold = response.data.excessValueThreshold;
                this.insuranceDataModel.tierId = response.data.tierId;
                this.emitUpdatedInsurance();
            }
        });
    }

    onInsurerChange(event: any) {
        this.insuranceDataModel.isChanged = true;
        this.loadCoverageType(event.insuranceId);
    }

    onCoverageRateChange() {
        this.insuranceDataModel.isChanged = true;
        this.emitCalCostBreakdown.emit();
    }

    onCoverageTypeChange(event: any) {
        this.insuranceDataModel.isChanged = true;
        this.isEstimateInsuranceUpdateOnChange = true;
        this.insuranceDataModel.insuranceRateId = event.insuranceRateId;
        this.getInsuranceRateByIdAndCost();
    }

    selectAllToggle() {
        this.selectAllChecked = !this.selectAllChecked;

        this.categoryLookup.forEach((item) => {
            item.isActive = this.selectAllChecked;
        });

        this.insuranceForm.form.markAsDirty();
    }

    onCoverageCategoryChange(selectedCategory: any) {
        this.insuranceDataModel.isChanged = true;

        if (selectedCategory.coverageCategoryName === 'All' && !selectedCategory.isActive) {
            this.selectAllChecked = false;
        } else {
            this.selectAllChecked = this.isAllCategoriesChecked();
        }

        this.emitCoverageTypeChange.emit({ coverageName: selectedCategory.coverageCategoryName, isChecked: selectedCategory.isActive });
    }

    isAllCategoriesChecked(): boolean {
        for (const item of this.categoryLookup) {
            if (!item.isActive) {
                return false;
            }
        }
        return true;
    }

    onChangeMarkupPercentage(event: any) {
        this.insuranceDataModel.isChanged = true;
        this.isEstimateInsuranceUpdateOnChange = true;
        this.emitUpdatedInsurance();
    }

    emitUpdatedInsurance() {
        this.emitUpdateMarkupPercentage.emit();
    }

    onChangeMinimumCharge(event: any) {
        this.insuranceDataModel.isChanged = true;
    }

    getInsuranceRateByIdAndCost() {
        this.insuranceService.getRateById(`&InsuranceRateId=${this.insuranceDataModel.insuranceRateId}&TotalValue=${this.insuredTotalCost}`).subscribe(response => {
            if (response.isSuccess) {
                this.insuranceDataModel.coverage_Rate = response.data.cost.toFixed(2);
                this.insuranceDataModel.markupPercentage = response.data.markupPercentage;
                this.insuranceDataModel.minimum_Charge = response.data.minimum_Charge.toFixed(2);
                this.insuranceDataModel.excessValueThreshold = response.data.excessValueThreshold;
                this.insuranceDataModel.tierId = response.data.tierId;
                this.emitUpdatedInsurance();
            }
        });
    }
}
